<template>
  <page-layout
    title="收到的询价"
    class="p-ReceivedInquiry"
  >
    <znl-gridmodule
      height="auto"
      :loading="loading"
      :on-init="onInit"
      :item-source="datas"
      :columns="columns"
      :is-fields-search="false"
      :total-count="totalCount"
      :table-row-class-name="listRowClassName"
      :on-page-changed="onBindData"
      :page-size="pageSize"
      :page-index="pageIndex"
      :cell-line-height="48"
      align="left"
      :class="[datas.length === 0 ? 'empty-data-table' : '']"
      :style="{height: datas.length === 0 ? '30px' : '800px'}"
    >
    </znl-gridmodule>
    <div
      class="empty-data"
      v-if="datas.length === 0 && !loading"
    >
      <div class="receivedDefault">

      </div>
      <p>暂无数据</p>
    </div>
  </page-layout>
</template>
<script>
import { ReceivedInquiryColumns } from '../scripts/ColumnsConfig';
import PageLayout from '../PageLayout';
import { httpPost } from '../../assets/scripts/http';
import TradingStore from '../../store';

export default {
  name: 'ReceivedInquiry',
  components: { PageLayout },
  props: {
    companyClickHandler: Function
  },
  data() {
    return {
      store: TradingStore,
      totalCount: 1,
      pageSize: 20,
      pageIndex: 1,
      columns: [],
      datas: [],
      loading: false
    };
  },
  methods: {
    listRowClassName(rowObj) {
      if (rowObj.rowIndex % 2 !== 0) {
        return 'background-gray';
      } else {
        return '';
      }
    },
    async onInit() {
      const vm = this;
      // 采购商
      const SupplierNameColumn = ReceivedInquiryColumns.find(item => {
        return item.binding === 'BuyerName';
      });
      SupplierNameColumn.renderCell = (h, rowObj) => {
        let STypeText = '';
        let STypeClass = 'stype-cell';
        switch (rowObj.row.SType) {
          case 4:
          case 8:
            STypeText = '正';
            STypeClass = 'stype-cell stype-z';
            break;
          case 6:
          case 9:
            STypeText = '现';
            STypeClass = 'stype-cell stype-b';
            break;
          default:
            break;
        }
        return h(
          'div',
          {
            class: 'segmentation-rows'
          },
          [
            h('p', [
              h(
                'span',
                {
                  class: 'HoverCommon',
                  on: {
                    click(event) {
                      if (vm.companyClickHandler) {
                        vm.companyClickHandler({
                          CompanyName: rowObj.row.BuyerName,
                          CompanyID: rowObj.row.BuyerGuid
                        });
                      }
                      event.stopPropagation();
                    }
                  }
                },
                rowObj.row.BuyerName
              ),
              STypeText && h('span', { class: STypeClass }, STypeText)
            ]),
            h('p', { class: 'time-row' }, rowObj.row.RFQ_TimePhrase)
          ]
        );
      };
      // 需求型号/品牌
      const DemandModelColumn = ReceivedInquiryColumns.find(item => {
        return item.binding === 'Model';
      });
      DemandModelColumn.renderCell = (h, rowObj) => {
        return h(
          'div',
          {
            class: 'segmentation-rows'
          },
          [
            h('p', rowObj.row.Model),
            h('p', { class: 'time-row' }, rowObj.row.Brand)
          ]
        );
      };
      // 需求量
      const QtyColumn = ReceivedInquiryColumns.find(item => {
        return item.binding === 'RequiredQty';
      });
      QtyColumn.className = 'td-RequiredQty';
      QtyColumn.renderCell = (h, rowObj) => {
        return h(
          'div',
          {
            class: 'segmentation-rows cell-RequiredQty'
          },
          [h('p', rowObj.row.RequiredQty)]
        );
      };
      // 我的型号/品牌
      const MyModelColumn = ReceivedInquiryColumns.find(item => {
        return item.binding === 'MyModel';
      });
      MyModelColumn.className = 'td-MyModel';
      MyModelColumn.renderCell = (h, rowObj) => {
        return h(
          'div',
          {
            class: 'segmentation-rows'
          },
          [
            !rowObj.row.Offering &&
              h(
                'p',
                {
                  class:
                    rowObj.row.MyModel !== rowObj.row.Model
                      ? 'different-cell'
                      : ''
                },
                rowObj.row.MyModel
              ),

            !!rowObj.row.Offering &&
              h('p', [
                h('znl-input', {
                  props: {
                    width: '100%',
                    height: 22,
                    border: true,
                    value: rowObj.row.MyModel
                  },
                  on: {
                    input(value) {
                      rowObj.row.MyModel = value;
                    }
                  }
                })
              ]),

            !rowObj.row.Offering &&
              h(
                'p',
                {
                  class:
                    'time-row ' +
                    (rowObj.row.Brand && rowObj.row.MyBrand !== rowObj.row.Brand
                      ? 'different-cell'
                      : '')
                },
                rowObj.row.MyBrand
              ),

            !!rowObj.row.Offering &&
              h('p', [
                h('znl-input', {
                  props: {
                    width: '100%',
                    height: 22,
                    border: true,
                    value: rowObj.row.MyBrand
                  },
                  on: {
                    input(value) {
                      rowObj.row.MyBrand = value;
                    }
                  }
                })
              ])
          ]
        );
      };
      // 我的库存
      const StockColumn = ReceivedInquiryColumns.find(item => {
        return item.binding === 'Qty';
      });
      StockColumn.renderCell = (h, rowObj) => {
        if (!rowObj.row.Offering) {
          rowObj.row.TemporaryModel = rowObj.row.MyModel;
          rowObj.row.TemporaryBrand = rowObj.row.MyBrand;
          rowObj.row.TemporaryStock = rowObj.row.InvQty;
          rowObj.row.TemporaryPrice = rowObj.row.Price;
          rowObj.row.TemporaryInvoice = rowObj.row.IsNeedInvoice;
        }
        return h(
          'div',
          {
            class: 'segmentation-rows'
          },
          [
            !rowObj.row.Offering &&
              h(
                'p',
                {
                  class:
                    rowObj.row.InvQty < rowObj.row.RequiredQty
                      ? 'different-cell'
                      : ''
                },
                rowObj.row.InvQty
              ),

            !!rowObj.row.Offering &&
              h('div', [
                h('znl-input', {
                  props: {
                    width: '100%',
                    height: 22,
                    border: true,
                    value: rowObj.row.InvQty
                  },
                  on: {
                    input(value) {
                      rowObj.row.InvQty = value;
                    }
                  }
                }),
                h('div', [
                  h(
                    'znl-button',
                    {
                      props: {
                        type: 'text'
                      },
                      on: {
                        click() {
                          httpPost('tradeCentre/saveSupplierStockInfo', {
                            BDLineGuid: rowObj.row.BDLineGUID,
                            Model: rowObj.row.MyModel,
                            Brand: rowObj.row.MyBrand,
                            InvQty: rowObj.row.InvQty
                          }).then(res => {
                            if (res.Code === 0 && res.Data) {
                              rowObj.row.Offering = false;
                              vm.onBindData();
                            } else {
                              rowObj.row.MyModel = rowObj.row.TemporaryModel;
                              rowObj.row.MyBrand = rowObj.row.TemporaryBrand;
                              rowObj.row.InvQty = rowObj.row.TemporaryStock;
                              rowObj.row.Price = rowObj.row.TemporaryPrice;
                              rowObj.row.IsNeedInvoice =
                                rowObj.row.TemporaryInvoice;
                              rowObj.row.Offering = false;
                            }
                          });
                        }
                      }
                    },
                    '保存'
                  ),
                  h(
                    'znl-button',
                    {
                      props: {
                        type: 'text'
                      },
                      on: {
                        click() {
                          rowObj.row.MyModel = rowObj.row.TemporaryModel;
                          rowObj.row.MyBrand = rowObj.row.TemporaryBrand;
                          rowObj.row.InvQty = rowObj.row.TemporaryStock;
                          rowObj.row.Price = rowObj.row.TemporaryPrice;
                          rowObj.row.IsNeedInvoice =
                            rowObj.row.TemporaryInvoice;
                          rowObj.row.Offering = false;
                        }
                      }
                    },
                    '取消'
                  )
                ])
              ]),

            !rowObj.row.Offering &&
              rowObj.row.Status === 1 &&
              h('i', {
                class: 'iconfont icon-edit_ic',
                attrs: {
                  title: '修改型号/品牌/库存'
                },
                on: {
                  click() {
                    rowObj.row.Offering = true;
                  }
                }
              })
          ]
        );
      };
      // 报价/票
      const OfferColumn = ReceivedInquiryColumns.find(item => {
        return item.binding === 'Offer';
      });
      OfferColumn.renderCell = (h, rowObj) => {
        const QuotationRecord = rowObj.row.QuotationRecord || [];
        if (rowObj.row.Status === 1 || rowObj.row.AgainOffering) {
          // 未报价 或者 正在再次报价
          return h(
            'div',
            {
              class: 'segmentation-rows padding-left-20'
            },
            [
              h('znl-input', {
                props: {
                  width: 75,
                  height: 22,
                  border: true,
                  value: rowObj.row.Price
                },
                on: {
                  input(value) {
                    rowObj.row.Price = value;
                  }
                }
              }),
              h('div', [
                h(
                  'el-checkbox',
                  {
                    props: {
                      value: rowObj.row.IsNeedInvoice
                    },

                    on: {
                      change(value) {
                        rowObj.row.IsNeedInvoice = value;
                      }
                    }
                  },
                  '可开票'
                )
              ])
            ]
          );
        } else {
          // 已报价
          return h(
            'div',
            {
              class: 'segmentation-rows padding-left-20'
            },
            [
              // 历史报价记录
              rowObj.row.QuoteCount > 1 &&
                h(
                  'el-popover',
                  {
                    props: {
                      placement: 'bottom',
                      width: '280',
                      trigger: 'hover',
                      'popper-class': 'c-ReceivedInquiry'
                    }
                  },
                  [
                    QuotationRecord.map((item, index) => {
                      return h(
                        'div',
                        {
                          class: 'znl-Timeline-Trading clearfix'
                        },
                        [
                          h(
                            'div',
                            {
                              class:
                                'pull-left znl-Timeline-com znl-Timeline-left'
                            },
                            item.CreatedTime
                          ),
                          h(
                            'div',
                            {
                              class:
                                'pull-left znl-Timeline-com znl-Timeline-center'
                            },
                            index === QuotationRecord.length - 1
                              ? '供应商报价:'
                              : '供应商重新报价:'
                          ),
                          h(
                            'div',
                            {
                              class:
                                'pull-left znl-Timeline-com znl-Timeline-right'
                            },
                            [h('span', '¥'), h('span', item.Price)]
                          )
                        ]
                      );
                    }),
                    h('i', {
                      class: 'iconfont icon-history_ic',
                      slot: 'reference',
                      on: {
                        mouseenter() {
                          httpPost('tradeCentre/searchQuotePriceHistory', {
                            BDLineGuid: rowObj.row.BDLineGUID,
                            IQGuid: rowObj.row.IQGUID,
                            IsOrderbyCreatedTimeDesc: true,
                            SearchType: 2
                          }).then(res => {
                            if (res.Code === 0) {
                              rowObj.row.QuotationRecord = res.Data;
                            }
                          });
                        }
                      }
                    })
                  ]
                ),
              // 报价
              h(
                'p',
                {
                  class: ''
                },
                [
                  h(
                    'span',
                    {
                      class: 'price-span'
                    },
                    [h('span', '¥'), h('span', rowObj.row.Price)]
                  ),
                  h(
                    'span',
                    { class: 'span-IsNeedInvoice' },
                    rowObj.row.IsNeedInvoice ? '可开票' : ''
                  ),
                  h('i', {
                    class: 'iconfont icon-edit_ic',
                    attrs: {
                      title: '重新报价'
                    },
                    on: {
                      click() {
                        rowObj.row.AgainOffering = true;
                      }
                    }
                  })
                ]
              ),
              // 时间
              h('p', { class: 'time-row ' }, rowObj.row.ReplyTimePhrase)
            ]
          );
        }
      };
      // 操作
      const OperationColumn = ReceivedInquiryColumns.find(item => {
        return item.binding === 'Operation';
      });
      OperationColumn.renderCell = (h, rowObj) => {
        if (rowObj.row.Status === 1 || rowObj.row.AgainOffering) {
          return h(
            'znl-button',
            {
              props: {
                'style-type': 'main',
                width: 46,
                height: 22,
                disabled: !rowObj.row.Price
              },
              on: {
                click() {
                  vm.sendOffer(rowObj.row);
                }
              }
            },
            '发送'
          );
        } else if (rowObj.row.Status === 2) {
          return h('span', '已报价');
        } else if (rowObj.row.Status === 3) {
          return h('span', '已忽略');
        }
      };
      this.columns = ReceivedInquiryColumns;
      this.onBindData();
    },
    onBindData(PageIndex = 1) {
      this.loading = true;
      httpPost('tradeCentre/getquotedlist', {
        PageIndex,
        PageSize: 15
      })
        .then(res => {
          this.loading = false;

          if (res.Code === 0) {
            const ResList = res.Data.ResultList || [];
            const Datas = ResList.map((item, index) => {
              return {
                ...item,
                ...{
                  Offering: false,
                  AgainOffering: false,
                  TemporaryModel: '',
                  TemporaryBrand: '',
                  TemporaryStock: '',
                  TemporaryPrice: '',
                  TemporaryInvoice: '',
                  MyModel: item.Model,
                  MyBrand: item.Brand,
                  ID: index,
                  QuotationRecord: []
                }
              };
            });
            this.datas = Datas;
            this.pageIndex = res.Data.PageIndex;
            this.totalCount = res.Data.TotalCount;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    sendOffer(row) {
      const Params = [
        Object.assign({}, row, { SupplierStatus: 2, Qty: row.RequiredQty })
      ];
      httpPost('im/sendquotedprice', Params).then(res => {
        if (res.Code === 0) {
          row.AgainOffering = false;
          this.onBindData();
          this.$succMess('发送成功');
          Params[0].SupplierID = Params[0].BuyerGuid;
          Params[0].SupplierName = Params[0].BuyerName;
          this.$ch('SendQuotedPrice', Params);
        } else {
          this.$succMess(res.Message);
        }
      });
    }
  }
};
</script>
<style lang="scss">
.p-ReceivedInquiry {
  .stype-cell {
    padding: 0 1px;
    color: #fff;
    font-size: 12px;
    border: 1px solid #ff2200;
    box-sizing: border-box;
    margin-left: 5px;
  }
  .stype-z {
    background-color: #ff2200;
  }
  .stype-b {
    background-color: #fdf7a0;
    color: #ff2200;
  }
  .icon-edit_ic {
    display: none;
  }
  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #eef4ff;
    .icon-edit_ic {
      display: block;
    }
  }

  .el-table {
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    tr {
      &.background-gray {
        background-color: #f5f5f5;
      }
    }
    td {
      border-bottom: none;
    }
    td,
    th.is-leaf {
      border-right: none;
    }
    .znl-cell-header {
      .header-label {
        text-align: left;
      }
    }
  }
  .znl-label-column-Offer {
    .header-label {
      padding-left: 25px;
    }
  }
  .znl-label-column-Operation {
    .znl-cell-header {
      .header-label {
        text-align: center;
      }
    }
  }
  .segmentation-rows {
    line-height: 24px;
    text-align: left;
    position: relative;
    .span-IsNeedInvoice {
      color: rgba(0, 0, 0, 0.3);
      padding-left: 2px;
    }
    .time-row {
      color: $--fontcolor-dark-2;
    }
    .price-span {
      color: #ee7700;
      font-size: 12px;
      font-weight: bold;
      padding-right: 5px;
    }
    &.padding-left-20 {
      padding-left: 20px;
    }
    .icon-history_ic {
      position: absolute;
      top: 0px;
      left: 0;
      color: #ee7700;
    }
    .icon-edit_ic {
      position: absolute;
      top: 11px;
      right: 0;
      color: #167cdb;
      cursor: pointer;
    }
    .el-checkbox__label {
      font-size: 12px;
    }
  }
  .border-cell {
    border-left: 1px dashed #ccc !important;
  }
  // .td-RequiredQty {
  //   padding-right: 30px;
  //   .cell-RequiredQty {
  //     height: 100%;
  //     border-right: 1px dashed #ccc;
  //   }
  // }
  // .znl-label-column-MyModel .header-label,
  // .td-MyModel{
  // 	 padding-left: 50px;
  // }
  .el-table {
    .znl-current-cell .znl-tablecell {
      border-width: 0;
      padding: 0 5px;
      background-color: transparent;
      line-height: 48px !important;
    }
  }
  .znl-grid-component {
    &.empty-data-table {
      .footer,
      .el-table__body-wrapper {
        display: none;
      }
    }
  }
  .empty-data {
    text-align: center;
    padding-top: 160px;
    p {
      color: #808080;
      line-height: 30px;
    }
    .receivedDefault {
      width: 234px;
      height: 163px;
      margin: 0 auto;
      background-image: url('./imgs/enquiry-received_default_pic.png');
      background-size: 100% 100%;
    }
  }
  .different-cell {
    color: #ff2200;
  }
}
</style>

